/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from 'app/components/common/SideBar.jsx';
import Content from 'app/components/common/Content.jsx';
import { Breakpoint } from 'react-socks';
import axios from 'axios';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
            error: null
        };

    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error
        };
    }

    componentDidCatch(error, errorInfo) {
        let errorData = {
            userId: this.props.user.detail.id,
            error: error.message,
            errorInfo: JSON.stringify({
                errorInfo,
                browser: window.navigator.userAgent,
                stack: error.stack,
                location: window.location,
                translated: false
            })
        };

        if (document.getElementsByTagName('html')[0].className.match(/translated/)) {
            errorData.errorInfo.translated = true;
        }

        // if a chunk error is present reload the page to get the fresh new references
        if (error.message.match(/Loading Chunk/i)) {
            window.location.reload(true);
            return;
        }

        axios({
            url: `${this.props.app.config.apiUrl}/error/report`,
            data: errorData,
            headers: { "Content-type": "multipart/form-data" },
            method: 'POST',
            withCredentials: true,
            responseType: 'json'
        });

    }

    render() {
        let error = this.state.error,
            errorString = (this.state.error !== null) ? error.toString() : '',
            mainError = null,
            action = null,
            content = null;


        action = (
            <a href="#" className="error-action" onClick={(e) => {
                    e.preventDefault();
                    window.location.reload()
            }}>go back</a>
        );

        mainError = (
            <div className="app-error clearfix">
                <div className="error-header-wrapper">
                    <div className="icon-background">
                        <i className="icon ion-ios-rainy"></i>
                    </div>
                    <div className="copy-wrapper">
                        <h1>Sorry...</h1>
                        <p>we weren't expecting that</p>
                    </div>
                </div>
                <div className="error-detail-section">
                    <p>{"Here are some details you can share with our support team if you'd like:"}</p>
                    <textarea className="error-textarea" defaultValue={errorString}></textarea>
                    <div className="error-action-section">
                        {action}
                    </div>
                </div>
            </div>
        );

        if (this.state.hasError) {
            switch (this.props.level) {
                case "top":
                case "feature":
                    content = mainError;
                    break;

                case "view":
                    content = (
                        <div>
                            <Breakpoint desktop only>
                                <Sidebar/>
                            </Breakpoint>
                            <Content main={mainError}/>
                        </div>
                    );
                    break;

                default:
                    break;
            }

            return content;
        }

        return this.props.children;

    }
}

ErrorBoundary.displayName = "ErrorBoundary";

ErrorBoundary.propTypes = {
    level: PropTypes.string,
    userId: PropTypes.number
};

ErrorBoundary.defaultProps = {
    level: '',
    userId: 0
};

export default ComponentWithContext(ErrorBoundary);
